export interface TimedRun {
  id: string;
  date: string;
  status: "playing" | "solved" | "failed";
  attempts: string[];
  maxAttempts: number;
  startedAt: number;
  finishedAt: number | null;
  elapsedMs: number | null;
  name: string | null;
}

export interface GameResponse {
  date: string;
  serverNow: number;
  run: TimedRun | null;
}

export interface LeaderboardEntry {
  id: string;
  rank: number;
  name: string;
  elapsedMs: number;
  attempts: number;
  maxAttempts: number;
}

export interface LeaderboardResponse {
  date: string;
  entries: LeaderboardEntry[];
}

export function normalizeDisplayName(value: unknown): string | undefined {
  if (typeof value !== "string") return undefined;
  const name = value.normalize("NFKC").trim().replace(/\s+/g, " ");
  if ([...name].length < 2 || [...name].length > 24) return undefined;
  if (!/^[\p{L}\p{M}\p{N} ._'\-]+$/u.test(name)) return undefined;
  return name;
}